import { scope } from "@otto-ec/global-resources/debug";
import { cookie } from "@otto-ec/global-resources/cookie";

/**
 *
 */
export const exactagScope = scope("ofc.exactag");

/**
 *
 */
export const exactagState = {
  isFirstRun: true,

  /*                                                    */
  centralComplete: false,
};

const seleniumCookie = "seleniumBypassAdvertising";

/**
 *
 *
 */
export function seleniumBypassAdvertising(): boolean {
  if (!cookie.exists(seleniumCookie)) return true;
  return cookie.get(seleniumCookie) === "true";
}

/**
 *
 *
 *
 *
 */
export function jsonParseSafe<T>(data: string): T | null {
  try {
    return JSON.parse(data);
  } catch (e) {
    return null;
  }
}
